module.exports = __webpack_public_path__ + "img/06-0资质1-3.6b916f34.png";